import { useMutation, useQueryClient } from "@tanstack/react-query";
import { toast } from "react-toastify";
import { apisiseci } from "../../../api";
import { AttendanceLocalService } from "../../../../@types/attendance-local-service";
import { AttendanceLocalServiceResponse } from "../../../../@types/attendance-local-service-response";
import { AxiosError } from "axios";

export type AttendanceLocalServiceCreateData = Pick<
    AttendanceLocalService,
    | "servico_id"
    | "unidade"
    | "agendamento"
    | "atendimento"
>;

export function useAttendanceLocalServiceCreate() {
    const queryClient = useQueryClient();
    const token = localStorage.getItem("gov_access_token_sso");

    const mutation = useMutation({
        mutationKey: ["attendance-local", "service", "create"],
        mutationFn: async (data: AttendanceLocalServiceCreateData) => {
            const response = await apisiseci.post<AttendanceLocalServiceResponse>(
                '/cms/servicos_unidades/', data,
                { headers: { Authorization: `Bearer ${token}` } }
            );
            return response.data;
        },
        onSuccess: async () => {
            toast.success("Serviço adicionado com sucesso!");

            await queryClient.invalidateQueries({
                queryKey: ["attendance-local", "service", "list"],
            });

            await queryClient.invalidateQueries({
                queryKey: ["service-available", "list"],
            });
        },
        onError: (error: AxiosError<{ detail: string }>) => {
            toast.error(
                error.response.data.detail || "Algo deu errado, tente novamente!"
            );
            console.log(error);
        },
    });

    return mutation;
}
